import { ArrowRight } from 'lucide-react';
import { ButtonSpinner } from '../../../helpers/UI/ButtonSpinner/ButtonSpinner';

const COMPACT_CANCEL_BTN =
  'cancelBtn !w-auto !h-9 !px-4 !py-0 !text-[14px] disabled:opacity-50 disabled:cursor-not-allowed';
const COMPACT_SUBMIT_BTN =
  'submitBtn !w-auto !h-9 !px-4 !py-0 !text-[14px] inline-flex items-center disabled:opacity-60 disabled:cursor-not-allowed';

type StepFooterProps = {
  currentStep: number;
  totalSteps: number;
  activating: boolean;
  canProceedFromFirstStep: boolean;
  canSubmitActivation: boolean;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
};

const StepFooter = ({
  currentStep,
  totalSteps,
  activating,
  canProceedFromFirstStep,
  canSubmitActivation,
  onBack,
  onNext,
  onSubmit,
}: StepFooterProps) => {
  const isFinalStep = currentStep === totalSteps - 1;

  if (isFinalStep) {
    return (
      <div className='flex justify-between gap-4'>
        <button type='button' className={COMPACT_CANCEL_BTN} onClick={onBack}>
          Back
        </button>
        <button
          className={`${COMPACT_SUBMIT_BTN} gap-2`}
          onClick={onSubmit}
          disabled={!canSubmitActivation}
        >
          {activating && <ButtonSpinner />}
          Upload & activate
        </button>
      </div>
    );
  }

  return (
    <div className={`flex gap-4 ${currentStep === 0 ? 'justify-end' : 'justify-between'}`}>
      {currentStep > 0 && (
        <button className={COMPACT_CANCEL_BTN} onClick={onBack}>
          Back
        </button>
      )}
      <button
        className={COMPACT_SUBMIT_BTN}
        onClick={onNext}
        disabled={currentStep === 0 && !canProceedFromFirstStep}
      >
        <div className='flex justify-between gap-2 items-center'>
          {currentStep === 2 ? <span>Next</span> : <span>Accept & continue</span>}
          <ArrowRight size={14} />
        </div>
      </button>
    </div>
  );
};

export default StepFooter;
